<div id="canton" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg" fxLayout="row" fxLayoutAlign="space-between center">

      <!-- APP TITLE -->
      <div fxLayout="row" fxLayoutAlign="start center">

        <button class="mr-0 mr-sm-16" mat-icon-button (click)="back()">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <div fxLayout="column" fxLayoutAlign="start start"
          *fuseIfOnDom>
          <div class="h2">
            <span>{{ 'main.eLearning' | translate }}</span>
          </div>
          <div class="subtitle secondary-text">
            <span>{{ 'elearning.preview' | translate }}</span>
          </div>
        </div>
      </div>
      <!-- / APP TITLE -->

      <div>
        @if (elearning?.recommendButton && !elearning?.recommendationCreated) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="createRecommendation()">
            <span>{{'event.recommend' | translate}}</span>
          </button>
        }

        @if (elearning?.recommendButton && elearning?.recommendationCreated && elearning?.canRemoveRecommendation) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0"
            (click)="removeRecommendation()">
            <span>{{'event.remove_recommendation' | translate}}</span>
          </button>
        }

        <span matTooltip="{{'event.recommendation_created' | translate}}">
          @if (elearning?.recommendButton && elearning?.recommendationCreated && !elearning?.canRemoveRecommendation) {
            <button mat-raised-button
              class="save-product-button mat-white-bg mt-16 mt-sm-0"
              disabled >
              <span>{{'event.recommend' | translate}}</span>
            </button>
          }
        </span>

        @if (elearning?.unsubscribe) {
          <button mat-raised-button
            class="save-product-button mat-white-bg mt-16 mt-sm-0" (click)="unsubscribeElearning()">
            <span>{{'blog.unsubscribe' | translate}}</span>
          </button>
        }
      </div>

    </div>
    <!-- / HEADER -->

    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg">

      <!-- CONTENT -->
      <div class="content">
        @if (elearning) {
          <elearning-detail [elearning]="elearning"></elearning-detail>
        }
      </div>
      <!-- / CONTENT -->

    </div>
    <!-- / CONTENT CARD -->

  </div>
  <!-- / CENTER -->
</div>

